import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Attivita from './components/Attivita';
import Eventi from './components/Eventi';
import ChiSiamo from './components/ChiSiamo';
import Membership from './components/Membership';
import Blog from './components/Blog';
import Partecipa from './components/Partecipa';
import Volontari from './components/Volontari';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import DecorativeElements from './components/DecorativeElements';
import PrivacyPolicy from './components/PrivacyPolicy';
import './App.css';

const App: React.FC = () => {
  const [showPrivacy, setShowPrivacy] = useState<boolean>(false);

  const handlePrivacyClick = (): void => {
    setShowPrivacy(true);
  };

  const handlePrivacyClose = (): void => {
    setShowPrivacy(false);
  };

  return (
    <div className="App">
      <DecorativeElements />
      <Header />
      <main>
        <Hero />
        {/* <Attivita />
        <Eventi /> */}
        <ChiSiamo />
        {/* <Membership />
        <Blog />
        <Partecipa />
        <Volontari />
        <FAQ /> */}
      </main>
      <Footer onPrivacyClick={handlePrivacyClick} />
      {showPrivacy && <PrivacyPolicy onClose={handlePrivacyClose} />}
    </div>
  );
};

export default App;

